import t_12_2528 from './KZ.Т.12.2528 Kazaly.svg'
import t_12_2528_b from './KZ.Т.12.2528 Kazaly black.svg'

export default [
  t_12_2528,
  t_12_2528_b
]
